<ng-container [ngSwitch]="viewMode">
  <ng-container *ngSwitchDefault>
    <app-filters
      [filters]="universalMediaListModalFilters"
      [isDataLoading]="isDataLoading"
      (filtersChanged)="onFiltersChanged($event)">
    </app-filters>

    <ng-container *ngIf="!isDataLoading; else universalMediaListsLoadingTpl">
      <div class="segments-list" *ngIf="universalMediaLists?.length; else noUniversalMediaListsTpl">
        <ng-container *ngFor="let universalMediaList of universalMediaLists">
          <div class="app-segment-wrapper margin-bottom-small">
            <app-universal-media-domains
              [rxDealMode]="rxDealMode"
              [isInternalUser]="portalType === 'exchange'"
              [universalMediaList]="universalMediaList"
              [universalMediaMediaType]="universalMediaList.segment?.type"
              [mode]="'select'"
              [status]="getUniversalMediaListStatus(universalMediaList)"
              (selected)="onUniversalMediaListSelected($event)"
              (viewRequested)="onUniversalMediaListViewRequested($event)">
            </app-universal-media-domains>
          </div>
        </ng-container>
      </div>
      <ng-template #noUniversalMediaListsTpl>
        <div class="margin-top-2 margin-bottom-2 text-center bold-font">
          <div>No universal media lists found.</div>
          <div *ngIf="portalType === 'partner'">Please contact your Nexxen Account Manager.</div>
        </div>
      </ng-template>
    </ng-container>
    <ng-template #universalMediaListsLoadingTpl>
      <div class="margin-top-2 margin-bottom-2">
        <nz-spin nzTip="Loading universal media lists..."></nz-spin>
      </div>
    </ng-template>
    <ng-container *ngIf="!isDataLoading && universalMediaListsMetaData">
      <div class="margin-top-1 display-flex justify-content-center">
        <nz-pagination
          [nzPageIndex]="universalMediaListsMetaData.rxMetaData?.currentPage"
          [nzPageSize]="universalMediaListsMetaData.rxMetaData?.itemsPerPage"
          [nzTotal]="universalMediaListsMetaData.rxMetaData?.totalItems"
          (nzPageIndexChange)="onPageChanged($event)">
        </nz-pagination>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'view'">
    <div class="universal-media-content-view" *ngIf="universalMediaContentMetaData">
      <div class="margin-bottom-1">
        <div class="bold-font medium-font">
          Universal Media List: {{selectedUniversalMediaListForView?.name}}
        </div>
      </div>

      <app-filters
        [filters]="universalMediaContentFilters"
        [isDataLoading]="universalMediaContentMetaData?.isLoading"
        (filtersChanged)="onUniversalMediaContentSearch($event)">
      </app-filters>

      <ng-container *ngIf="!universalMediaContentMetaData?.isLoading; else universalMediaContentLoadingTpl">
        <div *ngIf="universalMediaContentList?.length; else noUniversalMediaContentTpl">
          <app-table
            [tableData]="universalMediaContentList"
            [table]="universalMediaContentTable"
            [tableColumns]="universalMediaContentTableColumns"
            [tableType]="'serverSide'"
            [isTableLoading]="universalMediaContentMetaData?.isLoading"
            [totalRows]="universalMediaContentMetaData?.totalElements"
            [isPaginated]="true"
            [hasFooter]="true"
            [hasSizeChanger]="true"
            [idProp]="'id'"
            (tablePageChanged)="onUniversalMediaContentPageChanged($event)"
            (tableSortChanged)="onUniversalMediaContentSortChanged($event)">
          </app-table>
        </div>
        <ng-template #noUniversalMediaContentTpl>
          <div class="margin-top-2 margin-bottom-2 text-center bold-font">
            <div>{{ UNIVERSAL_MEDIA_CONTENT_MESSAGES.noDataMessage }}</div>
          </div>
        </ng-template>
      </ng-container>
      <ng-template #universalMediaContentLoadingTpl>
        <div class="margin-top-2 margin-bottom-2 text-center">
          <nz-spin nzTip="Loading media content..."></nz-spin>
        </div>
      </ng-template>
    </div>
  </ng-container>
</ng-container> 